export const stepOneData = [
  {
    heading: "Why Choose the Axis Bank Car Loan EMI Calculator?",
    // paras before heading

    infoList: [
      {
        heading: "Accurate Estimates: ",
        description:
          "Know your monthly EMI, total interest, and repayment cost.",
      },
      {
        heading: "Easy to Use: ",
        description: "Get quick results without any complex calculations.",
      },
      {
        heading: "Scenario Testing: ",
        description: "Compare different loan tenures and interest rates.",
      },
      {
        heading: "Financial Clarity: ",
        description: "Plan your car purchase with confidence.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    heading: "Axis Bank Car Loan Features",
    tableContent: {
      heading: [
        {
          head: "Loan Type",
        },
        {
          head: "Interest Rate ",
        },
        {
          head: "Maximum Tenure",
        },
        {
          head: "Processing Fees",
        },
      ],
      row: [
        {
          type: "New Car Loan",
          interest: "Starting at 8.5%",
          tenure: "Up to 7 years",
          fee: "1% of loan amount",
        },
        {
          type: "Used Car Loan",
          interest: "Starting at 10.5%",
          tenure: "Up to 5 years",
          fee: "1.5% of loan amount",
        },
        {
          type: "Electric Vehicle Loan",
          interest: "Special Rates Available",
          tenure: "Up to 7 years",
          fee: "1% of loan amount",
        },
      ],
    },
  },
];

export const stepThreeData = [
  {
    heading: "Factors Affecting Your Car Loan EMI ",

    factorsList: [
      {
        heading: "Loan Amount: ",
        info: "Higher loan amounts mean higher EMIs.",
      },
      {
        heading: "Interest Rate: ",
        info: "A lower rate reduces monthly EMI and total interest.",
      },
      {
        heading: "Loan Tenure: ",
        info: "Longer tenure reduces EMI but increases total interest.",
      },
      {
        heading: "Credit Score: ",
        info: "A high credit score can get you better interest rates.",
      },
      {
        heading: "Prepayment and Foreclosure Fees: ",
        info: "Check Axis Bank's policies for early repayment.",
      },
    ],
  },
];

export const stepFourData = [
  {
    heading: "How to Use the Axis Bank Car Loan EMI Calculator?",
  },
];
export const stepFiveData = [
  {
    heading: "How Your Credit Score Affects Your Car Loan?",

    creditScoreList: [
      {
        head: "750 & Above: ",
        info: "Get the lowest interest rates and best loan offers.",
      },
      {
        head: "650-749: ",
        info: "Standard interest rates with possible negotiation.",
      },
      {
        head: "Below 650: ",
        info: "Higher interest rates and stricter eligibility.",
      },
    ],
    tip: "Improve your credit score by maintaining a low credit utilization ratio and making timely repayments on existing loans.",
  },
];

export const stepSixData = [
  {
    heading: "Understanding APR vs Interest Rate ",
    paraOne:
      "The Annual Percentage Rate (APR) includes processing fees and other charges along with the interest rate, giving you a true cost of the loan. A lower APR can help you save significantly.",
    tip: "Don't just compare interest rates—always check the APR to get the full picture of your loan cost.",
  },
];

export const stepSevenData = [
  {
    heading: "Axis Bank Car Loan EMI Examples ",
    tableContent: {
      heading: [
        {
          head: "Loan Amount",
        },
        {
          head: "Tenure",
        },
        {
          head: "Interest Rate",
        },
        {
          head: "Monthly EMI",
        },
        {
          head: "Total Interest Paid",
        },
      ],
      row: [
        {
          amount: "₹5,00,000",
          tenure: "5 Years	",
          interest: "8.75% p.a.",
          emi: "₹10,324",
          paid: "₹1,19,420",
        },
        {
          amount: "₹8,00,000",
          tenure: "7 Years	",
          interest: "8.5% p.a.",
          emi: "₹12,613",
          paid: "₹2,59,500",
        },
      ],
    },
    tip: "Opting for a slightly shorter tenure can help reduce the total interest paid on your car loan.",
  },
];
